import { TeacherDirectorySectionCombinedProps } from './types';

const usePresenter = (props: TeacherDirectorySectionCombinedProps): TeacherDirectorySectionCombinedProps => {
  return props;
};

export default usePresenter;
